import * as lottie_1 from '../../images/UseCases/Consultants/agendaChoice_and_edition.json'
import * as lottie_2 from '../../images/UseCases/Consultants/agendaChoice_and_edition.json'
import * as lottie_3 from '../../images/UseCases/Consultants/agendaChoice_and_edition.json'

import { LayoutUseCase } from '../../components/Layout/LayoutUseCase'
import React from 'react'
import { UseCase } from '../../components/UseCases/components/type'
import { UseCases } from '../../components/UseCases/UseCases'
import { graphql } from 'gatsby'
import { useI18next } from 'gatsby-plugin-react-i18next'

const customer_success = () => {
    const { t } = useI18next()
    const use_case: UseCase = {
        title: t(`Use_case_6_title`),
        name: t(`Use_case_6_name`),
        description: t(`Use_case_6_description`),
        cube: 'cube_customer-succes',
        manAsset: 'man_customer-succes',
        color: 'bg-[#B52DAB]',
        from_color: 'from-[#7C3EFF]',
        to_color: 'to-[#F31A4E]',
        cards: [
            {
                title: t(`Use_case_6_caroussel_title_1`),
                description: t(`Use_case_6_caroussel_description_1`),
                lottie: lottie_1,
            },
            {
                title: t(`Use_case_6_caroussel_title_2`),
                description: t(`Use_case_6_caroussel_description_2`),
                lottie: lottie_2,
            },
            {
                title: t(`Use_case_6_caroussel_title_3`),
                description: t(`Use_case_6_caroussel_description_3`),
                lottie: lottie_3,
            },
        ],
    }

    return (
        <LayoutUseCase>
            <UseCases useCase={use_case} />
        </LayoutUseCase>
    )
}

export default customer_success
export const query = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
    }
`
